import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ImageCroppedEvent } from "ngx-image-cropper";

@Component({
   selector: "mapfre-auditlib-file-uploader-cropper",
   templateUrl: "./file-uploader-cropper.component.html",
   styleUrls: ["./file-uploader-cropper.component.scss"]
})
export class FileUploaderCropperComponent implements OnInit {
   display: boolean = false;
   imageToCrop: any = "";
   newImage: any = "";

   @Input()
   label: any;

   @Input()
   cropperOptions: any;

   @Input()
   form: any;

   @Output()
   imageSubmit = new EventEmitter();

   constructor() { }

   ngOnInit() {
   }

   onChangeUpload(event) {
      if (event.target.value) {
         this.imageToCrop = event;
         this.display = true;
      } else {
         this.display = false;
      }
   }
   imageCropped(event: ImageCroppedEvent) {
      this.newImage = event.base64;
   }
   submit() {
      this.form.setValue(this.newImage);
      this.display = false;
      //this.imageSubmit.emit(this.newImage);
   }
   cancel() {
      this.display = false;
      this.imageSubmit.emit(false);
   }
}
